import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { clearAuthErrors, fetchGlobalSettings, editGlobalSettings, fetchTaxrateStates, clearGlobalSettingsErrors } from '../actions'; // eslint-disable-line max-len
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import ShowSettings from '../components/settings/ShowSettings';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  taxrates: PropTypes.object,
  globalSettings: PropTypes.object,
  query: PropTypes.object,
  error: PropTypes.any,
};

class SettingsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }

  componentWillMount() {
    this.props.dispatch(clearGlobalSettingsErrors());
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchTaxrateStates());
    this.props.dispatch(fetchGlobalSettings());
  }
  componentWillReceiveProps() {
  }
  saveEditSettings(settings) {
    this.setState({
      edited: true,
    });
    this.props.dispatch(editGlobalSettings(settings));
  }

  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };

    return (
      <div className="settings component" style={authPage}>
        <ShowSettings
          settings={this.props.globalSettings}
          onSave={data => {this.saveEditSettings(data)}}
        />
      </div>
    );
  }
}


SettingsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

SettingsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    query: ownProps.location.query,
  };
}

export default connect(mapStateToProps)(SettingsPage);



// WEBPACK FOOTER //
// ./src/containers/SettingsPage.js